// src/main.tsx
if (import.meta.env.PROD) {
  import('./main-prod');
} else {
  import('./main-dev');
}
